<template>
    <h4 class="font-BwGRadual text-xl font-medium md:text-3xl">
        <slot></slot>
    </h4>
</template>
<script setup></script>
